export default __webpack_public_path__ + "static/HalvarBreit-Rg-a8d6a1e08262f1fa27983ffe5b6d8390.woff2";